import { useEffect } from "react";
import { type } from "./QuizRunner";
import { size } from "lodash";

export default function InprogressQuizPayload(isReview , data, answers){
  useEffect(() => {
    if (
      data &&
      data.time_spent &&
      size(answers) === 0 &&
      isReview === undefined &&
      data.type === type.Exercise
    ) {
      data.questions.forEach((question_item) => {
        if (size(question_item.user_selected) !== 0) {
          answers.push({
            question_id: question_item.id,
            selected_answers: question_item["user_selected"],
          });
        }
      });
    }
  }, [data, isReview]);
}